import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Input, InputNumber, Switch, message } from "antd";
import { RxStar } from "react-icons/rx";
import { createAccumulationUnit } from "../../../api/Services";
import CustomBreadcrumb from "../../../components/breadcrumb/Breadcrumb";
import styles from "./NewAccumulationUnit.module.scss";

const NewAccumulationUnit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getBasePath = () => {
    if (location.pathname.startsWith("/fidelity")) {
      return "/fidelity/units";
    }
    return "/commercial-intelligence/configuration/units";
  };

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const ok = await createAccumulationUnit({
        name: values.name,
        code: values.code,
        baseAccumulationFactor: values.baseAccumulationFactor,
        specificAccumulationFactor: values.specificAccumulationFactor,
        accumulationUnitValue: values.accumulationUnitValue,
        useAccumulationForPayment: Boolean(values.useAccumulationForPayment),
        useClientTiers: Boolean(values.useClientTiers),
      });
      if (ok) {
        message.success(t("Common-CreateSuccessMessage"));
        navigate(getBasePath());
      } else {
        message.error(t("Common-ErrorMessage"));
      }
    } catch (error) {
      message.error(t("Common-ValidationErrorMessage"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <CustomBreadcrumb
          items={[
            {
              icon: <RxStar />,
              label: t("NavBar-Units"),
              path: getBasePath(),
            },
            {
              label: t("Common-CreateNew"),
              isCurrentPage: true,
            },
          ]}
        />
        <div className={styles.actions}>
          <Button onClick={() => navigate(getBasePath())}>{t("Common-Cancel")}</Button>
          <Button type="primary" loading={loading} onClick={handleCreate}>
            {t("Common-Add")}
          </Button>
        </div>
      </div>

      <div className={styles.content}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            useAccumulationForPayment: false,
            useClientTiers: false,
          }}
        >
          <Form.Item
            label={t("Common-Name")}
            name="name"
            rules={[{ required: true, message: t("Common-NameNotEntered") }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t("Common-Code")}
            name="code"
            rules={[{ required: true, message: t("Common-Code") }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Factor de acumulacion base" name="baseAccumulationFactor">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Factor de acumulacion especifico" name="specificAccumulationFactor">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Valor de la unidad de acumulacion" name="accumulationUnitValue">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="Usa acumulacion para pagar compras"
            name="useAccumulationForPayment"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item label="Usa tiers de clientes" name="useClientTiers" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default NewAccumulationUnit;
